// src/apiService.js
import axios from 'axios'; // Make sure this line is present

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
    return `${process.env.REACT_APP_API_SECURITY_KEY}`;
  };
export const registerServiceType = async (req) => {
  try {
    const response = await fetch(`${API_BASE_URL}/client/servicetype/save`, {
      method: 'POST',
      headers: {
        'auth_key': `${getAuthKey()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    // Check for specific status codes in the response
    if (data.statusCode === 1002) {
      // Returning a specific error message if the user already exists
      return { error: data.result };
    }else if(data.statusCode===1001){
      return { success: 'Added Successfully' };
    }else{
      return { error: 'Fail' };
    }
    return data; // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};


// Fetch all countries from the API
export const fetchServiceTypeData = async (clientId) => {
  try {
    
    const response = await axios.get(`${API_BASE_URL}/client/servicetype/getservicetypelist/${clientId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching countries:', error);
    alert('Error fetching countries:'+ error);
    throw error;
  }
};

export const fetchServiceTypeDataById = async (serviceId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/client/servicetype/getservicetype/${serviceId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching Data:', error);
    alert('Error fetching Data:', error);
    throw error;
  }
};


export const updateServiceType = async (req) => {
  try {
    const response = await fetch(`${API_BASE_URL}/client/servicetype/updateservicetype`, {
      method: 'POST',
      headers: {
        'auth_key': `${getAuthKey()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();// Check for specific status codes in the response
    if (data.statusCode === 1002) {
      // Returning a specific error message if the user already exists
      return { error: data.result };
    }else if(data.statusCode===1001){
      return { success: "Updated Successfully" };
    }else if(data.statusCode===1003){
        return { error: data.result };
    }
    else if(data.statusCode===1004){
        return { error: data.result };
    }else{
      return { error: 'Fail' };
    }
    alert(data);
    return data; // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

// Fetch all ColumnNames from the API
export const fetchColumnNames = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/client/servicetype/getallcolumnnames`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
  //   if (!response.ok) {
  //     alert('Network response was not ok');
  //     throw new Error('Network response was not ok');
  // }
  //console.log(response);
  const data = response.data;
  //const data = await response.json();
  if (data.statusCode === 1002) {
      return { error: data.result };
  } else if (data.statusCode === 1001) {
      return data.result ;
  } else {
      return { error: 'Fail' };
  }
} catch (error) {
console.error('Error fetching :', error);
alert('Error fetching :'+ error);
throw error;
}
};

export const fetchTitlesByServiceTypeId = async (serviceTypeId) => {
  try {
    //[{'title':'First'},{'title':'Second'},{'title':'Third'}];//
    const response =  await axios.get(`${API_BASE_URL}/client/servicetype/getservicetypetitlesbyservicetypeid/${serviceTypeId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    
    if(!response.data){
      return null;
    }
    return response.data.titles; // Return the list of countries
  } catch (error) {
    console.error('Error fetching Data:', error);
    alert('Error fetching Data:', error);
    throw error;
  }
};


export const registerServiceTypeTitles = async (req) => {
  try {
     const response = await fetch(`${API_BASE_URL}/client/servicetype/updateservicetypetemplate`, {
      method: 'POST',
      headers: {
        'auth_key': `${getAuthKey()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
   // Check for specific status codes in the response
    //const data = {'statusCode': 1002,'result': 'success'};
    if (data.statusCode === 1002) {
      // Returning a specific error message if the user already exists
      return { error: data.result };
    }else if(data.statusCode===1001){
      return { success: 'Added Successfully' };
    }else{
      return { error: 'Fail' };
    }
    return data; // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

// Download Excel file based on serviceTypeId and serviceTypeName
export const downloadTitlesExcel = async (serviceTypeId, serviceTypeName) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/client/servicetype/getservicetypetitles/${serviceTypeId}`, {
      headers: {
        'auth_key': `${getAuthKey()}`,
      },
      responseType: 'blob' // Ensure the response is received as a blob
    });

    // Create a URL for the blob object and trigger download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${serviceTypeName}_titles.xlsx`); // Set filename using serviceTypeName
    document.body.appendChild(link);
    link.click();

    // Clean up by revoking the object URL
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);

  } catch (error) {
    console.error('Error downloading Excel file:', error);
    alert('Error downloading Excel file');
    throw error;
  }
};

// Fetch all countries from the API
export const fetchServiceTypeTemplateData = async (clientId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/client/servicetype/getservicetypetemplateslist/${clientId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching countries:', error);
    alert('Error fetching countries:'+ error);
    throw error;
  }
};